<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import ButtonGroup from 'dashboard/components-next/buttonGroup/ButtonGroup.vue';

defineProps({
  isMobileSidebarOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);

const route = useRoute();

const isConversationRoute = computed(() => {
  const CONVERSATION_ROUTES = [
    'home',
    'account_conversations',
    'inbox_dashboard',
    'inbox_conversation',
    'conversation_through_inbox',
    'label_conversations',
    'conversations_through_label',
    'team_conversations',
    'conversations_through_team',
    'folder_conversations',
    'conversations_through_folders',
    'conversation_mentions',
    'conversation_through_mentions',
    'conversation_unattended',
    'conversation_through_unattended',
    'conversation_participating',
    'conversation_through_participating',
    'inbox_view_conversation',
  ];
  return CONVERSATION_ROUTES.includes(route.name);
});

const toggleSidebar = () => {
  emit('toggle');
};
</script>

<template>
  <div
    v-if="!isConversationRoute"
    id="mobile-sidebar-launcher"
    data-mobile-sidebar-launcher
    class="acl-mobile-sidebar-launcher fixed bottom-4 ltr:left-4 rtl:right-4 z-40 transition-transform duration-200 ease-out block md:hidden"
    :class="[
      {
        'ltr:translate-x-48 rtl:-translate-x-48': isMobileSidebarOpen,
      },
    ]"
    @click.stop
  >
    <ButtonGroup
      class="rounded-full bg-n-alpha-2 backdrop-blur-lg p-1 shadow hover:shadow-md"
    >
      <Button
        icon="i-lucide-menu"
        no-animation
        data-mobile-sidebar-launcher
        class="!rounded-full !bg-n-solid-3 dark:!bg-n-alpha-2 !text-n-slate-12 text-xl transition-all duration-200 ease-out hover:brightness-110"
        lg
        @click.stop="toggleSidebar"
      />
    </ButtonGroup>
  </div>
  <template v-else />
</template>

<style scoped>
@media (max-width: 767px) {
  .acl-mobile-sidebar-launcher {
    bottom: calc(82px + env(safe-area-inset-bottom, 0px));
    z-index: 1003;
  }
}
</style>
